export const storage = {
	zeroProducts: {
		noProproductIsSelected: "Nenhum produto selecionado",
	},
	removeProduct: {
		noProproductIsSelected: "Nenhum produto selecionado",
	},
	layout: {
		goBack: "Voltar",
	},
	indicators: {
		cost: {
			title: "Valor total em estoque",
		},
		turnover: {
			high: "Maior giro",
			low: "Menor giro",
		},
		zeroed: {
			title: "Produtos zerados",
			seeMore: "Ver Mais",
		},
		intervalNotice: "Valores referentes aos ultimos 90 dias",
		updatedAt: "Atualizado em {{date}}",
		noZeroedProductsFound: "Nenhum produto zerado encontrado",
		arialLabel: {
			dashboardTitle: "Painel de métricas de estoque",
			indicatorsList: "Indicadores de estoque",
			dataVisualization: "Visualização de dados de {{title}}",
			seeMoreButton: "Ver mais produtos com quantidade zero",
			zeroedProductsPreview: "Prévia de produtos com quantidade zero",
			storageUnit: "Unidade de estoque {{name}}",
			productWithZeroQuantity: "{{name}}, produto com quantidade zero",
		},
	},
	modalXML: {
		title: "Importar XML",
		warningMessage: {
			line1:
				"Selecione o estoque de destino, baixe a planilha exemplo, preencha e importe novamente.",
			line2:
				"Atenção! O valor dos produtos é informado em centavos. Ex: 123 equivale a {{currencySymbol}} 1,23",
		},
		form: {
			label: {
				storage: "Estoque",
				xml: "XML",
			},
			placeholder: {
				xml: "Escolha um arquivo .xml para importar",
			},
			validation: {
				missingField: "Campo obrigatório",
			},
			submit: "Importar Nota",
		},
	},
	modalManualChange: {
		title: {
			add: 'Adicionar produto "{{prodName}}"',
			subtract: 'Remover produto "{{prodName}}"',
		},
		okText: {
			add: "Adicionar produto",
			subtract: "Remover produto",
		},
		cancel: "Cancelar",
		message: {
			add: "Digite a quantidade de produto que você quer adicionar e o preço de custo",
			subtract:
				"Digite a quantidade que você deseja remover e uma observação caso necessário",
		},
		form: {
			hasProductionRuleWarning:
				"Este produto possui ficha técnica e seus itens serão reduzidos do estoque apenas quando estiverem zerados.",
			label: {
				quantity: "Quantidade",
				costPrice: "Preço de custo",
				obs: "Observação",
			},
			validation: {
				invalidQuantity: "Quantidade invalida",
				missingProductInfo: "Faltando informação de produto",
				missingActionInfo: "Faltando informação de ação",
			},
		},
	},
	header: {
		searchPlaceHolder: "Buscar por produto",
		importXML: "Importar via XML",
		transferProducts: "Transferir produtos",
		addProducts: "Adicionar produtos",
		addProductsManually: "Adicionar produtos manualmente",
		actionsToolbar: "Ações do estoque",
		importViaXlsx: "Importar via Excel",
	},
	table: {
		columns: {
			name: "produto",
			category: "categoria",
			quantity: "quantidade",
			action: "ação",
			lastCost: "último preço",
			avgCost: "preço médio",
			totalCost: "custo total",
		},
		actions: {
			zeroStorage: "Zerar estoque",
			removeProducts: "Remover produtos",
			label: "Ações em lote",
			message: "Selecione o check box para ações em lote",
		},
		confirmationModal: {
			warnignHiddenProductsInSearch:
				"Atenção, alguns produtos podem estar escondidos por causa da busca, limpe a busca para continuar",
			deleteSingle: {
				title: "Remover produto",
				message:
					"Ao confirmar a ação você remove permanentemente estes itens do estoque. Deseja continuar?",
				confirmMessage: "Sim, desejo remover",
			},
			deleteMultiple: {
				title: "Remover produto",
				message:
					"Ao confirmar a ação você remove permanentemente estes itens do estoque. Deseja continuar?",
				confirmMessage: "Sim, desejo remover",
			},
			zero: {
				title: "Zerar quantidade dos produtos",
				messagePrefix: "Você está prestes a zerar a quantidade",
				allMessage: "de todos os produtos selecionados ({{total}} produtos).",
				selectedMessage: "dos {{selectedTotal}} produtos selecionados.",
				messageSuffix: "Tem certeza de que deseja continuar?",
				confirmMessage: "Zerar os produtos",
			},
		},
		filters: {
			categoryPlaceholder: "Filtrar por categoria",
			productPlaceholder: "Buscar por nome do produto",
			suggestions: "Sugestões",
			other: "Outras",
		},
		selectedProductsCount: "Todos os produtos selecionados: {{total}} produtos",
	},
	inputViaXlsx: {
		header: {
			title: "Importar produtos via Excel",
		},
		layout: {
			importProductsTable: "Importe sua tabela de produtos",
			tutorial: "Adicione 1 ou mais produtos de uma vez importando uma planilha.",
		},
		form: {
			totalProducts: "Total de produtos",
			successfullyImported: "Produtos importados",
			productsWithErrors: "Produtos com erro",
			alert: {
				title: "Produtos com erro",
				message:
					"Identificamos alguns produtos com informações incorretas. Baixe a planilha com os erros, corrija os dados e, em seguida, realize a importação novamente.",
			},
			tooltip: {
				totalProducts: "Sua tabela possuia {{totalProducts}} produtos",
				successfullyImported:
					"{{totalProducts}} produtos já foram importados com sucesso para seu estoque",
				productsWithErrors: "Baixe a tabela com erros e faça o upload novamente",
			},
		},
		sheet: {
			columns: {
				productName: "Produto",
				quantity: "Quantidade",
				unit: "Unidade de medida",
				costPrice: "Preço de custo",
				costType: "Tipo de custo",
			},
			costType: {
				byUnit: "Custo unitário",
				byTotal: "Custo total",
			},
			sampleFileName: "exemplo_entrada_produtos.xlsx",
			errorFileName: "entrada_produtos_com_erro.xlsx",
		},
	},
};
